import { Dropdown } from "@/crud/form/Dropdown";
import { BASE_URL } from "@/dashboardQueries";
import { PaginatedResponse } from "@/models/Dashboard";
import { Form } from "@/models/form";
import { getActionBasedOnType } from "@/utils/flows";
import axios from "axios";
import { useMemo } from "react";
import { useQuery } from "react-query";
import { ActionHeader } from "../ActionHeader";

export const CompletesAForm = () => {
  const fetchForms = async (): Promise<Array<Form>> => {
    const { data } = await axios.get(`${BASE_URL}/dashboard/forms/dropdown`);
    return data;
  };

  const {
    data: forms,
    error: formsError,
    isLoading: formsLoading,
  } = useQuery("formsDropdown", fetchForms);

  const formOptions =
    forms?.map((form) => ({
      id: form.id,
      value: form.name,
    })) || [];

  const action = useMemo(() => getActionBasedOnType("completesForm"), []);

  // console.log(forms);

  return (
    <div>
      {formsLoading ? (
        <>Loading</>
      ) : (
        action && (
          <div>
            <ActionHeader action={action} category="Trigger" />

            <div className="mt-4">
              <div className="mb-2">
                <h3 className="dark:text-zinc-300 text-sm">Configuration</h3>
                <p className="text-xs dark:text-zinc-600 mt-0.5">
                  Form to start this flow
                </p>
              </div>
              <div className="-mx-[1px]">
                <Dropdown name="form" options={formOptions} />
              </div>
            </div>
          </div>
        )
      )}
    </div>
  );
};
